import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {ParentAPIService} from '../../parent.api.service';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../../toast-service';
import {CrystalclearClearingBackUrl} from "../../config/crystalclear-clearing-back-url";
import {ApiValidation} from "../../../model/api/api-validation";
import {ApiFileUploadRequest} from "../../../model/api/api-file-upload-request";
import {FlexTradesRequest} from "../../../model/clearing/flex/flex-trades-request";
import {BatchUpdateRequest} from "../../../model/api/batch-update-request";
import {FlexTrade} from "../../../model/clearing/flex/flex-trade";
import {FieldResult} from "../../../model/api/field-result";

@Injectable({
  providedIn: 'root'
})
export class ClearingFlexService extends ParentAPIService implements OnInit, OnDestroy {

  constructor(http: HttpClient,
              private toastService: ToastService) {

    super(http);
  }

  ngOnInit(): void {
  }


  ngOnDestroy() {
  }

  public getOrderTemplates(): Observable<FieldResult<any>> {
    return this.getStore(CrystalclearClearingBackUrl.GET_CLEARING_FLEX_ORDER_TEMPLATES);
  }

  public getTradeTemplates(): Observable<FieldResult<any>> {
    return this.getStore(CrystalclearClearingBackUrl.GET_CLEARING_FLEX_TRADE_TEMPLATES);
  }

  public ordersRequest(request: ApiFileUploadRequest): Observable<ApiValidation<any>> {
    return this.post(CrystalclearClearingBackUrl.POST_CLEARING_FLEX_ORDERS_REQUEST, request);
  }

  public tradesRequest(request: FlexTradesRequest): Observable<ApiValidation<any>> {
    return this.post(CrystalclearClearingBackUrl.POST_CLEARING_FLEX_TRADES_REQUEST, request);
  }

  public deleteTrades(recordIds: string[]): Observable<ApiValidation<any>> {
    return this.post(CrystalclearClearingBackUrl.POST_CLEARING_FLEX_DELETE_TRADES, recordIds);
  }

  saveBatch(batchUpdateRequest: BatchUpdateRequest<FlexTrade>) {
    return this.post(CrystalclearClearingBackUrl.POST_CLEARING_FLEX_SAVE_BATCH, batchUpdateRequest);
  }

  public clearStorage(): void {
    this.clearStore(CrystalclearClearingBackUrl.GET_CLEARING_FLEX_ORDER_TEMPLATES);
    this.clearStore(CrystalclearClearingBackUrl.GET_CLEARING_FLEX_TRADE_TEMPLATES);
  }
}
